/// <reference path="references.ts" />
var PageSharedLayoutPrimary = /** @class */ (function () {
    //Methods
    function PageSharedLayoutPrimary() {
        var thisObj = this;
        //Get all linked elements
        this.sitePrimaryLayout = document.getElementsByClassName('sitePrimaryLayout')[0];
        //Make it so every submit button found in every form on the site is diabled when the form is submitted (solves numerous issues)
        //Fixes include the "The provided anti-forgery token was meant for user "", but the current user is "ACT-2JFD6AMVSN7C"." which is caused by users double-clicking on the login button
        //Note that this is NOT for security, as users can diable JS. This is only for avoiding user-unfriendly or confusing error messages
        $(this.sitePrimaryLayout).find('form').each(function () {
            $(this).submit(function (event) {
                $(this).find(':input[type=submit]').each(function () {
                    if (!$(this).attr('apfDontDisableOnSubmit')) { //Don't disable if the apfDontDisableOnSubmit="true" attribute exists on the button
                        $(this).prop('disabled', true);
                    }
                });
            });
        });
        $(this.sitePrimaryLayout).find('form').each(function () {
            var currentForm = this; //Get the current form
            $(this).find(':input[type=submit]').each(function () {
                if (!$(this).attr('apfDontDisableOnSubmit')) { //Don't disable if the apfDontDisableOnSubmit="true" attribute exists on the button
                    $(this).click(function (event) {
                        $('<input>').attr({
                            type: 'hidden',
                            name: $(this).attr('name'),
                            value: $(this).val()
                        }).insertBefore($(currentForm).children().first()); //Append to the start of the current form, instead of next to the button itself or the end of the form. Otherwise it may mess with any last-child CSS selectors
                    });
                }
            });
        });
        //Wrap all registered trademark symbols with <sup>, as it applies to almost every design mockup we receive - see here https://stackoverflow.com/questions/19364581/adding-superscript-sup-tags-around-all-trademark-and-registered-trademark-symb
        var regexp = /[\xAE]/;
        $('body :not(script,sup)').contents().filter(function () {
            return this.nodeType === 3 && (regexp.test(this.nodeValue));
        }).replaceWith(function () {
            return this.nodeValue.replace(regexp, '<sup>$&</sup>');
        });
        $('body :not(script,sup)').contents().filter(function () {
            return this.nodeType === 3;
        }).replaceWith(function () {
            return this.nodeValue.replace(/[™®©]/g, '<sup>$&</sup>');
        });
    }
    return PageSharedLayoutPrimary;
}());
//# sourceMappingURL=PageSharedLayoutPrimary.js.map